import React from 'react'

const Deep_Learning = () => {
  return (
    <div>
        {/* collapseFiftyFour */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftyFour">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyFour" aria-expanded="false" aria-controls="collapseFiftyFour">
                    Deep Learning<span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftyFour" className="accordion-collapse collapse" aria-labelledby="headingFiftyFour" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Module 1: Deep Learning Algorithms</strong>
                    <ul>
                        <li>CNN Convolutional Neural Network</li>
                        <li>RNN - Recurrent Neural Network</li>
                        <li>ANN - Artificial Neural Network</li>
                    </ul>

                    <strong>Module 2: Introduction to NLP</strong>
                    <ul>
                        <li>Text Pre-processing</li>
                        <li>Noise Removal</li>
                        <li>Lexicon Normalization</li>
                        <li>Lemmatization</li>
                        <li>Stemming</li>
                        <li>Object Standardization</li>
                    </ul>

                    <strong>Module 3: Text to Features(Feature Engineering)</strong>
                    <ul>
                        <li>Syntactical Parsing</li>
                        <li>Dependency Grammar</li>
                        <li>Part of Speech Tagging</li>
                        <li>Entity Parsing</li>
                        <li>Named Entity Recognition</li>
                        <li>Topic Modelling</li>
                        <li>N-Grams</li>
                        <li>TF - IDF</li>
                        <li>Frequency/Density Features</li>
                        <li>Word Embedding's</li>
                    </ul>

                    <strong>Module 4: Tasks of NLP</strong>
                    <ul>
                        <li>Text Classification</li>
                        <li>Text Matching</li>
                        <li>Levenshtein Distance</li>
                        <li>Phonetic Matching</li>
                        <li>Flexible String Matching</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Deep_Learning